export const getMask = (maska: string) => {
  if (!maska) return null;
  switch (maska) {
    case "phone":
      return {
        mask: "+7 (###) ###-##-##",
        eager: true,
      };
    case "card":
      return {
        mask: "#### #### #### ####",
        eager: true,
      };
    case "currency":
      return {
        number: {
          locale: "uk",
          fraction: 2,
          unsigned: true,
        },
        postProcess: (val: any) => (val ? `${val} ₽` : ""),
      };
    case "thousands":
      return {
        number: {
          locale: "ru",
          fraction: 0,
          unsigned: true,
        },
      };
    default:
      return {
        mask: maska,
      };
  }
};
